import { Route } from 'react-router-dom';
import Page from './../../components/Page';
import Player from './Player';
import Players from './Players';

import Paths from '../../constants/paths';
import ErrorMessages from '../../components/ErrorMessages.js';
import { observer } from 'mobx-react-lite';

const OutOfLeaguePlayersTab = ({ store }) => {
    return (
        <Page loading={!store.dataLoaded}>
            <div style={{ marginLeft: '2.5%' }}>
                <ErrorMessages messages={store.error} />
            </div>
            <Route exact path={Paths.OUT_OF_LEAGUE_PLAYERS}>
                <Players store={store} />
            </Route>
            <Route exact path={Paths.OUT_OF_LEAGUE_PLAYER}>
                <Player store={store} />
            </Route>
        </Page>
    );
};

export default observer(OutOfLeaguePlayersTab);
